import React from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Form from "../../common/Form";
import Row from "../../common/Row";
import Button from "../../common/Button";
import Fieldset from "../../common/Fieldset";

const BevestigingForm = (props) => {
    const {
        sportVlaanderenRoot,
        goToFirstTab
    } = props;

    return (
        <div id="eindForm">
            <Section>
                <Form
                    name="eind"
                    headerVisible={false}
                    isNotRequired
                >
                    <Fieldset>
                        <Row><div style={{ color: "#082b42", fontSize: "1.4375rem", fontWeight: "500", lineHeight: "28px", margin: "30px 0.83333% 0 0.83333%" }}>Bedankt!</div></Row>
                    </Fieldset>
                    <div style={{ width: "100%", height: "1px", backgroundColor: "#E6E6E6", marginTop: "30px" }}></div>
                    <Fieldset>
                        <p>Bedankt voor het melden van een nieuwe sportclub.<br />Een databeheerder zal de gegevens controleren en daarna opnemen in onze databank.</p>
                        <Row style={{ margin: "0 0 -40px 0" }}>
                            <a href={`${sportVlaanderenRoot}/SportDBPublic.Website/Organisatie/List?parenturl=${sportVlaanderenRoot}/waar-sporten/vind-een-sportorganisatie/`}><Button text={"Ga verder"} style={{ "minWidth": "200px", "float": "right" }} /></a>
                        </Row>
                    </Fieldset>
                </Form>
            </Section>
        </div>
    );
};

BevestigingForm.propTypes = {
    goToFirstTab: PropTypes.func,
    sportVlaanderenRoot: PropTypes.string
};

export default BevestigingForm;